<template lang="pug">
.crud
  loader(:visible="visible")
  .container-fluid
    vm-row.heading(vm-w="12")
      div
        h1 {{ sale.folio }}
      b-form-group
        vm-tabs
          vm-tab(vm-label='Información general' @click="flag = false")
            general-sale-information(:sale="sale")
            sale-detail-information(:sale="sale")
            sale-quotation-details-table(:sale="sale")
            sendings-customer-table(:sale="sale")
            receptions-details-table(:sale="sale")
          vm-tab(vm-label='Compras Proveedores' @click="flag = true")
            purchase-orders-component(:sale="sale" ref="purchase")
          vm-tab(vm-label='Importaciones y otros gastos' @click="flag = false")
            import-other-expenses(:sale="sale")
          vm-tab(vm-label='Pagos' @click="flag = false")
            invoice-numbers-information(:sale="sale")
          vm-tab(vm-label='Expediente' @click="flag = false")
            sale-registry(:sale="sale")
</template>

<script>
import GeneralSaleInformation from '@/components/additionals/GeneralSaleInformation.vue'
import SaleDetailInformation from '@/components/additionals/SaleDetailInformation.vue'
import SaleQuotationDetailsTable from '@/components/additionals/SaleQuotationDetailsTable.vue'
import SendingsCustomerTable from '@/components/additionals/SendingsCustomerTable.vue'
import ReceptionsDetailsTable from '@/components/additionals/ReceptionsDetailsTable.vue'
import PurchaseOrdersComponent from '@/components/additionals/PurchaseOrdersComponent.vue'
import InvoiceNumbersInformation from '@/components/additionals/InvoiceNumbersInformation.vue'
import ImportOtherExpenses from '@/components/additionals/ImportOtherExpenses.vue'
import SaleRegistry from '@/components/additionals/SaleRegistry.vue'
import Loader from '@/components/additionals/Loader.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'SaleDetail',
  components: {
    GeneralSaleInformation,
    SaleDetailInformation,
    SaleQuotationDetailsTable,
    SendingsCustomerTable,
    ReceptionsDetailsTable,
    PurchaseOrdersComponent,
    InvoiceNumbersInformation,
    ImportOtherExpenses,
    SaleRegistry,
    Loader
  },
  data: () => ({
    visible: false,
    flag: false,
    ranger: []
  }),
  computed: {
    ...mapGetters(['sale'])
  },
  watch: {
    flag (flag) {
      if (flag) {
        setTimeout(() => {
          this.$refs.purchase.defaultPurchaseOrder()
        }, 500)
      }
    }
  },
  async created () {
    this.visible = true
    await this.loadSaleInformation({ sale_id: this.$route.params.id }).then(() => {
      this.visible = false
    })
  },
  methods: {
    ...mapActions(['loadSaleInformation'])
  }
}
</script>

<style lang="scss" scoped>

.heading {
  margin-top: 20px;
  .form-group {
    width: 100%;
    .con-ul-tabs {
      border-bottom: 1px solid #e1e1e1da;
    }
  }
}
.vm-tabs--li {
  font-size: 20px;
  font-weight: bold;
  margin-right: 20px;
  &:last-child {
      margin-right: 0px;
  }
}
</style>
